import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import CompanyThemeApi from '@infrastructure/company-theme-api';
export const getCompanyThemeAsync = createAsyncThunk('companyTheme/getTheme', async (companyId, { rejectWithValue }) => {
    try {
        const response = await CompanyThemeApi.getCompanyThemeApi(companyId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCompanyThemeAsync = createAsyncThunk('companyTheme/updateTheme', async (request, { rejectWithValue }) => {
    try {
        const response = await CompanyThemeApi.updateCompanyThemeApi(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
